import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkTreeModule } from '@angular/cdk/tree';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ComponentSharedModule } from '@components/component.shared.module';
import { UiFolderTreeBreadCrumbsModule } from '@components/ui-folder-tree-breadcrumbs/ui-folder-tree-breadcrumbs.module';
import { UiFolderTreeModule } from '@components/ui-folder-tree/ui-folder-tree.module';
import { SharedModule } from '@modules';
import { TranslateModule } from '@ngx-translate/core';
import { UiSuggestModule } from '@uipath/angular/components/ui-suggest';
import { UiClickOutsideModule } from '@uipath/angular/directives/ui-click-outside';
import { UiContentLoaderModule } from '@uipath/angular/directives/ui-content-loader';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';
import { UiVirtualScrollRangeLoaderModule } from '@uipath/angular/directives/ui-virtual-scroll-range-loader';

import { UiFolderTreeModalComponent } from './ui-folder-tree-modal.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        MatCardModule,
        UiClickOutsideModule,
        CdkTreeModule,
        ComponentSharedModule,
        MatButtonModule,
        MatCheckboxModule,
        MatIconModule,
        MatInputModule,
        TranslateModule,
        UiNgLetModule,
        ScrollingModule,
        UiVirtualScrollRangeLoaderModule,
        UiSpinnerButtonModule,
        UiContentLoaderModule,
        UiFolderTreeModule,
        UiSuggestModule,
        UiFolderTreeBreadCrumbsModule,
    ],
    declarations: [
        UiFolderTreeModalComponent,
    ],
    exports: [
        UiFolderTreeModalComponent,
    ],
    entryComponents: [
        UiFolderTreeModalComponent,
    ],
})
export class UiFolderTreeModalModule { }
